import React, { useState, useEffect } from "react";
import {
    DownOutlined,
    LeftOutlined,
    LogoutOutlined,
    RightOutlined,
} from "@ant-design/icons";
import { Avatar, Layout, Menu } from "antd";
import SubMenu from "antd/lib/menu/SubMenu";
import Logo from "../../../assets/logo.png";
import { useNavigate, useLocation } from "react-router-dom";
import useProfile from "./useSidebar";
import { ReactComponent as DotIcon } from "../../../assets/dot.svg";
import { ReactComponent as UserIcon } from "../../../assets/user-icon.svg";
import LogoutIcon from "../../../assets/logout.png";
import collapsedIcon from "../../../assets/collapsed-icon.png";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser, setNavbarCollapsed } from "../../login/redux/actions";
import SelectLabsPopup from "./selectLabsPopover";
import {
  NotificationBell,
  NotificationModal,
  groupNotificationsByDate,
  getUnreadCount,
} from "../../../components/Notification";
import { useNotifications } from "../../../components/Notification/useNotifications";
import { getLSKey, LS_KEYS } from "../../../utils/localStorageHelper";

const SidebarComponent = (props) => {
    const { Sider } = Layout;
    const [shouldCollapse, setShouldCollapse] = useState(true);
    const [collapsed, setCollapsed] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const {
        user,
        logoutLoading
    } = useSelector((state) => state?.authReducer || {});

    const dispatch = useDispatch();
    const [menuItemsData] = useProfile();
    const [selectedLabs, setSelectedLabs] = useState([]);
    const [SelectLabsModalvisible, setSelectLabsModalVisible] = useState(false);
    const [notificationModalvisible, setNotificationModalVisible] = useState(false);
    const { notifications: notificationData, unreadCount, markAsRead, markAllAsRead } = useNotifications();
    const groupedNotifications = groupNotificationsByDate(notificationData);
    const { labs } = useSelector((state) => state.authReducer);
    const { user_labs } = useSelector((state) => state.userManagerReducer);
    const { allLabs } = useSelector((state) => state.labsSetupReducer);

    useEffect(() => {
        if (!user?.id) {
            setSelectedLabs([]);
            return;
        }
        let ls = localStorage.getItem(getLSKey(LS_KEYS.SELECTED_LABS, user.id));
        if (ls === null) {
            setSelectedLabs([]);
        } else {
            setSelectedLabs(JSON.parse(ls));
        }
    }, [location.pathname, user?.id, user_labs, allLabs]);

    const handleSelectedKey = () => {
        if (location.pathname.includes("/settings/users-manager/create-user")) {
            return "/settings/users-manager";
        }
        if (location.pathname.includes("/settings/users-manager/update-user")) {
            return "/settings/users-manager";
        }
        if (location.pathname.includes("/settings/variance-statuses")) {
            return "/settings/variance-statuses";
        }
        if (location.pathname.includes("/settings/lab-statuses")) {
            return "/settings/lab-statuses";
        }
        if (location.pathname.includes("/settings/revision-statuses")) {
            return "/settings/revision-statuses";
        }
        if (location.pathname.includes("/settings/clients-manager/create-client")) {
            return "/settings/clients-manager";
        }
        if (location.pathname.includes("/settings/clients-manager/update-client")) {
            return "/settings/clients-manager";
        }
        if (location.pathname.includes("/settings/material-templates/create-template")) {
            return "/settings/material-templates";
        }
        if (location.pathname.includes("/settings/material-templates/update-template")) {
            return "/settings/material-templates";
        }
        if (location.pathname.includes("/labs-setup/create-lab")) {
            return "/labs-setup";
        }
        if (location.pathname.includes("/labs-setup/update-lab")) {
            return "/labs-setup";
        }

        if (location.pathname.includes("/project/material-control")) {
            return `/project/material-control`;
        }

        if (location.pathname.includes("/project/progress-summary")) {
            return `/project/progress-summary`;
        }

        if (location.pathname.includes("/labs-stock-management/") && location.pathname !== "/labs-stock-management") {
            // Return the specific lab route for active state
            return location.pathname;
        }

        if (location.pathname === "/") {
            return "/";
        }

        return location.pathname;
    };

    const handleLogout = () => {
        dispatch(logoutUser({ navigate, id: user.id }));
    };

    const LabsList = () => {
        return selectedLabs.map((lab, i) => {
            const { client, labName, id } = lab.labSetup || lab;

            // Find user permissions for this Lab
            const projectPermission = user_labs?.find(up => up.labId === id)?.permissions;
            // const hasViewPermission = projectPermission?.general?.view;

            let className = "lab-doc-selected";
            let parentClass = "lab-doc-selected-parent";

            return (
                <Menu.Item
                    className={`menu-item-for-top-border${collapsed ? "-collapsed" : ""
                        } labs-submenu`} // projects-subitems-custom
                    key={`lab-${id}`}
                    eventKey={`lab-${id}`}
                    icon={
                        <DotIcon
                            fill="#FFFFFF"
                            className="labs-submenu-bullet"
                            style={{
                                width: "10px",
                                height: "10px",
                                fontSize: "10px",
                                margin: collapsed ? "0px" : "0px 15px 0px 0px",
                                fill: location.pathname === `/labs-stock-management/${id}` ? "#ED017F" : "white"
                            }}
                        />
                    }
                    onClick={() => navigate(`/labs-stock-management/${id}`)}
                    style={{
                        paddingLeft: collapsed ? "10px" : "42px",
                    }}
                >
                    <div style={{ height: "auto", minHeight: "40px", paddingBottom: "10px" }}>
                        <div
                            className="lab-name"
                            style={{
                                width: "auto",
                                maxWidth: "none",
                                lineHeight: "16px",
                                fontSize: "14px",
                                color: location.pathname === `/labs-stock-management/${id}` ? "#ED017F" : "white",
                                wordWrap: "break-word",
                                whiteSpace: "normal",
                                overflow: "visible",
                                wordBreak: "break-word",
                                hyphens: "auto",
                                paddingTop: "12px"
                            }}
                        >
                            <span style={{
                                display: "block",
                                wordWrap: "break-word",
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                                maxWidth: "none"
                            }}>{labName}</span>
                        </div>
                    </div>
                </Menu.Item>
            );
        });
    };

    const labsStockManagementMenuItem = (item) => {
        const { link } = item;

        return (
            <>
                <Menu.Item
                    onClick={() =>
                        setSelectLabsModalVisible(!SelectLabsModalvisible)
                    }
                    className={`subitems-custom select-lab`}
                    key={link}
                    style={{
                        padding: collapsed ? `0px !important` : "10px 15px 10px 45px",
                        paddingLeft: collapsed ? "10px" : "42px",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <div>
                            <span
                                style={{
                                    paddingLeft: "42px",
                                }}
                            >
                                Select Labs
                            </span>
                        </div>
                        <div>
                            <DownOutlined className="dropdown-icon" />
                        </div>
                    </div>
                </Menu.Item>
                {!SelectLabsModalvisible && <LabsList item={item} />}
            </>
        );
    };

    const menuSubItems = (item) => {
        const { name, link } = item;

        return (
            <Menu.Item
                onClick={() => navigate(link)}
                className="subitems-custom"
                key={link}
                style={{
                    padding: collapsed ? `0px !important` : "10px 15px 10px 45px",
                    paddingLeft: collapsed ? "10px" : "45px",
                }}
                icon={
                    <DotIcon
                        fill="#ffffff"
                        className="dot-icon"
                        style={{
                            margin: collapsed ? "0px" : "0px 5px 0px 0px",
                        }}
                    />
                }
            >
                {name}
            </Menu.Item>
        );
    };

    return (
        <>
            <SelectLabsPopup
                visible={SelectLabsModalvisible}
                setVisible={setSelectLabsModalVisible}
                setSelectedLabs={setSelectedLabs}
                selectedLabs={selectedLabs}
            />
            <Sider
                trigger={null}
                collapsible
                collapsed={collapsed}
                width={collapsed ? "70px" : `260px`}
                className={`main-sidebar${collapsed ? `-collapsed` : ""} `}
            >
            {shouldCollapse && (
                <span
                    onClick={() => {
                        setCollapsed(!collapsed);
                        dispatch(setNavbarCollapsed(!collapsed));
                    }}
                    className="sidebar-pin-icon"
                >
                    {collapsed ? <RightOutlined /> : <LeftOutlined />}
                </span>
            )}
            <div
                className="trigger sidebar-child-div"
            // onClick={() => shouldCollapse && setCollapsed(!collapsed)}
            >
                {collapsed ? (
                    <div
                        className="nav-collapsed-img-div"
                        style={{
                            margin: collapsed ? "20px 0" : "0px 10px",
                        }}
                        onClick={() => navigate("/")}
                    >
                        <img src={collapsedIcon} alt="" />
                    </div>
                ) : (
                    <div className="nav-uncollapsed-img-div">
                        <img
                            src={Logo}
                            alt="Logo"
                            style={{
                                margin: collapsed && "0px !important",
                            }}
                            onClick={() => navigate("/")}
                        />
                    </div>
                )}
            </div>
            <Menu
                theme="dark"
                mode="inline"
                className="sidebar-custom"
                defaultSelectedKeys={[location.pathname]}
                selectedKeys={[handleSelectedKey()]}
            >
                {menuItemsData.map((el) => {
                    const {
                        key,
                        src,
                        SvgImg,
                        name,
                        link,
                        hasSubItems,
                        subItems,
                        hasPermission,
                    } = el;

                    return hasSubItems && hasPermission ? (
                        <SubMenu
                            className={`menu-item-for-top-border${collapsed ? "-collapsed" : ""
                                }`}
                            key={key}
                            icon={
                                <SvgImg
                                    className="project-icon"
                                    style={{
                                        margin: collapsed ? "0px" : "0px 5px 0px 0px",
                                    }}
                                />
                            }
                            title={
                                !collapsed && (
                                    <span
                                        className={` ${key === "lab-control" ? "" : "settings-title-span"
                                            }`}
                                    >
                                        {name}
                                    </span>
                                )
                            }
                        >
                            {subItems?.map((el) => {
                                const { hasPermission, key } = el;
                                return hasPermission &&
                                (key === "lab-control"
                                    ? labsStockManagementMenuItem(el)
                                    : menuSubItems(el));
                            })}
                        </SubMenu>
                    ) : (
                        el?.hasPermission && (
                            <Menu.Item
                                onClick={() => navigate(link)}
                                key={link}
                                style={el.key === "1" && el.isNameTooLong ? { height: "80px" } : {}}
                                className={
                                    link === "/profile" || link === "/client-profile"
                                        ? `sidebar-custom-menuitem menu-item-for-top-border${collapsed ? "-collapsed" : ""
                                        }`
                                        : `menu-item-for-top-border${collapsed ? "-collapsed" : ""
                                        }`
                                }
                                icon={
                                    link === "/profile" || link === "/client-profile" ? (
                                        <div className="sidebar-profile-icon">
                                            <Avatar
                                                shape={"circle"}
                                                style={{
                                                    margin: collapsed ? "0px" : "0px 5px 0px 0px",
                                                }}
                                                src={src ? src : <UserIcon />}
                                            />
                                        </div>
                                    ) : (
                                        <Avatar
                                            className="profile-avatar"
                                            shape={"square"}
                                            style={{
                                                margin: collapsed ? "0px" : "0px 5px 0px 0px",
                                            }}
                                            src={
                                                SvgImg ? <SvgImg className="profile-svg-icon" /> : src
                                            }
                                        />
                                    )
                                }
                            >
                                {link === "/profile" || link === "/client-profile" ? (
                                    <div className="profile-menu-div">
                                        <div className="profile-username-div">
                                            {el.isNameTooLong ? (
                                                <>
                                                    <p style={{ marginTop: 7, padding: 0, lineHeight: '1.1' }}>{el.firstName}</p>
                                                    <p style={{ margin: 0, padding: 0, lineHeight: '1.1' }}>{el.lastName}</p>
                                                </>
                                            ) : (
                                                <p>{el.firstName} {el.lastName}</p>
                                            )}
                                            <span>{el.role}</span>
                                        </div>
                                        {!collapsed && (
                                            <div
                                                style={{
                                                    paddingRight: 12,
                                                    zIndex: 999999999999999,
                                                    display: "flex",
                                                    alignItems: "center",
                                                }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setNotificationModalVisible(true);
                                                }}
                                            >
                                                <NotificationBell
                                                    unreadCount={unreadCount}
                                                    onClick={(e) => {
                                                        e?.stopPropagation?.();
                                                        setNotificationModalVisible(true);
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div className="profile-menu-div">
                                        {link === "/projects-setup" || (el.firstName === undefined && el.lastName === undefined) ? (
                                            <div>{name}</div>
                                        ) : el.isNameTooLong ? (
                                            <div>
                                                <div>{el.firstName}</div>
                                                <div>{el.lastName}</div>
                                            </div>
                                        ) : (
                                            <div>{el.firstName} {el.lastName}</div>
                                        )}
                                    </div>
                                )}
                            </Menu.Item>
                        )
                    );
                })}
                <Menu.Item
                    className={`sidebar-custom-menuitem menu-item-for-top-border${collapsed ? "-collapsed" : ""
                        }`}
                    style={{
                        cursor: "default",
                        borderBottomColor: "transparent",
                    }}
                    key={"none"}
                ></Menu.Item>
                <Menu.Item
                    onClick={() => !logoutLoading && handleLogout()}
                    className={`sidebar-custom-menuitem menu-item-for-top-border${collapsed ? "-collapsed" : ""
                        } logout-menu-item`}
                    key={"logout"}
                    icon={<LogoutOutlined />}
                >
                    Logout {logoutLoading && "..."}
                </Menu.Item>
            </Menu>
            <NotificationModal
                visible={notificationModalvisible}
                onCancel={() => setNotificationModalVisible(false)}
                groupedNotifications={groupedNotifications}
                onMarkAsRead={markAsRead}
                markAllAsRead={markAllAsRead}
            />
            </Sider>
        </>
    );
};
export default SidebarComponent;
